module.exports = __webpack_public_path__ + "img/4-1.4a1b8fd3.svg";